import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return {
    addText: {
      marginLeft: 8,
      color: theme.palette.primary.main,
      cursor: 'pointer'
    },
    confirmIcon: {
      marginLeft: 8
    },
    chip: {
      backgroundColor: '#eeeeee',
      fontSize: 12,
      marginRight: 8
    },
    input: {
      width: '100%',
      height: 45,
      marginLeft: 8
    },
    deleteIcon: {
      width: 20,
      height: 20
    },
    prefixIcon: {
      fontSize: 20,
      color: '#9E9E9E'
    }
  };
});
export default useStyles;